export default "__VITE_ASSET__Bi8oasSm__"